import { InputAdornment } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { Input, InputCheck } from "../../../../controls";
import { AppContext } from "../../../../App";
import { useTranslation } from "react-i18next";

const ReceivePayment = ({
  setReceiveAmt,
  receiveAmt,
  receiveAmtRef,
  values,
  handleInpCheck,
  needToPayAmt,
}) => {
  const { t } = useTranslation();
  const { settings } = useContext(AppContext);
  const [change, setChange] = useState(0);

  const handleFocus = () => {
    if (receiveAmtRef.current) {
      receiveAmtRef.current.select();
    }
  };

  const handleInpChg = (e) => {
    setReceiveAmt(e.target.value);
  };

  useEffect(() => {
    setChange(parseFloat(receiveAmt) - parseFloat(needToPayAmt));
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [needToPayAmt, receiveAmt]);

  return (
    <div className="d-grid">
      <span className="fs-12 fw-6 tx-upp gray-color ml-10">
        {t("amountToPay")} *
      </span>
      <Input
        fullWidth
        placeholder="0.000"
        value={receiveAmt}
        type="number"
        variant="outlined"
        size="small"
        onChange={handleInpChg}
        onFocus={handleFocus}
        inputRef={receiveAmtRef}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <span className="grayLG-color fs-24">{settings?.curSymbol}</span>
            </InputAdornment>
          ),
          classes: {
            input: "fs-24 fw-6", // You can use this for custom styling
          },
        }}
      />
      {change > 0 ? (
        <div className="d-grid g-5 pl-10 mt-10">
          <span className="fs-16 fw-6 tx-upp gray-color pt-2">
            {t("change")}: &nbsp;&nbsp;{settings.curSymbol}{" "}
            {change.toFixed(settings.decimal)}
          </span>
          <div className="pl-5">
            <InputCheck
              label={
                <span className="fs-14 fw-5 tx-upp">
                  {t("keepChgAsCredit")}
                </span>
              }
              size="small"
              className="gray-color"
              onChange={handleInpCheck}
              name="changeAddedCredit"
              checked={values.changeAddedCredit}
            />
          </div>
        </div>
      ) : (
        <span
          className="fs-10 pl-10 fw-5 tx-upp gray-color"
          style={{ letterSpacing: "1px" }}
        >
          Edit to make a partial payment
        </span>
      )}
    </div>
  );
};

export default ReceivePayment;
